// TODO Fix everything with eslint-disable-next-line @typescript-eslint/no-redeclare
import * as types from 'types';

export type OfferState = types.IOffer;

export enum CoreActionTypes {
  UPDATE_VISA_STATUS = '@@student/core/UPDATE_VISA_STATUS',
  UPDATE_OFFER_FIELD = '@@visa/core/UPDATE_OFFER_FIELD',
}

export const Status = types.CoreStatusExtended;

export type Status = types.CoreStatusExtended;

export const { VisaStatus } = types;

export type VisaStatus = types.VisaStatus;

export enum RecordedInterviewActionTypes {
  RECORDED_INTERVIEW_ASSESSMENT = '@@student/offer/RECORDED_INTERVIEW_ASSESSMENT',
  RECORDED_INTERVIEW_ASSESSMENT_SUCCESS = '@@student/offer/RECORDED_INTERVIEW_ASSESSMENT_SUCCESS',
  RECORDED_INTERVIEW_ASSESSMENT_FAILURE = '@@student/offer/RECORDED_INTERVIEW_ASSESSMENT_FAILURE',
  RECORDED_INTERVIEW_EDIT_QUESTION_SCORE = '@@student/offer/RECORDED_INTERVIEW_EDIT_QUESTION_SCORE',
  RECORDED_INTERVIEW_EDIT_QUESTION_SCORE_SUCCESS = '@@student/offer/RECORDED_INTERVIEW_EDIT_QUESTION_SCORE_SUCCESS',
  RECORDED_INTERVIEW_EDIT_QUESTION_SCORE_FAILURE = '@@student/offer/RECORDED_INTERVIEW_EDIT_QUESTION_SCORE_FAILURE',
  REQUEST_VIDEO_PROCESSING_STATUS = '@@student/offer/REQUEST_VIDEO_PROCESSING_STATUS',
  REQUEST_VIDEO_PROCESSING_STATUS_SUCCESS = '@@student/offer/REQUEST_VIDEO_PROCESSING_STATUS_SUCCESS',
  REQUEST_VIDEO_PROCESSING_STATUS_FAILED = '@@student/offer/REQUEST_VIDEO_PROCESSING_STATUS_FAILED',
}

export enum OfferUpdateActionTypes {
  UPDATE_CALENDLY_INTERVIEW_INFO_STATUS = '@@student/offer/UPDATE_CALENDLY_INTERVIEW_INFO_STATUS',
}
